import SplitType from 'split-type'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);


let textToBeAnimated = Array.from(document.getElementsByClassName('animated-text'))

if(textToBeAnimated.length > 0){
    textToBeAnimated.forEach(x => {
        // let text = new SplitType(x)
        let textLinesTL = gsap.timeline({
            scrollTrigger:{
                trigger: x,
                // markers: true,
                start: 'top 90%',
            }
        })

        textLinesTL.from(x, {y:100, opacity:0})
    })
}
